import {
  AddEditMatterFormData,
  HumanContact,
  OrganizationContact,
} from './types';

export const constructMatterNameFromFormData = (
  formData: AddEditMatterFormData,
) => {
  const [humans, orgs] = formData.clients.reduce(
    (acc, contact) => {
      if (contact.type === 'human') {
        acc[0].push(contact);
      } else {
        acc[1].push(contact);
      }
      return acc;
    },
    [[], []] as [HumanContact[], OrganizationContact[]],
  );

  if (orgs.length > 0) {
    return orgs.map((contact) => contact.companyName).join('; ');
  }

  if (humans.length > 0) {
    // For multiple human contacts, join their names in the desired format
    // Assuming each contact in humanClients array has lastName and firstName
    return humans
      .map((contact) => `${contact.lastName}, ${contact.firstName}`)
      .join('; ');
  }

  return '';
};
